import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";

const money = (value) => `$${Number(value).toLocaleString("en-US", { minimumFractionDigits: 2 })}`;
const day = (value) => (value ? new Date(`${value.slice(0, 10)}T12:00:00`).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "");

export const ProgressNotePayLines = () => {
  const [data, setData] = useState(null);
  const [period, setPeriod] = useState("");
  const [error, setError] = useState("");
  useEffect(() => {
    api.get("/progress-notes/pay-lines", { params: { period } }).then((r) => setData(r.data)).catch((e) => setError(formatApiError(e)));
  }, [period]);
  return (
    <section className="progress-notes-pay-lines" data-testid="progress-notes-pay-lines" aria-busy={!data}>
      {error && <p className="form-message error-message">{error}</p>}
      <label className="progress-notes-period">Pay period<select data-testid="progress-notes-period-select" value={period} onChange={(e) => setPeriod(e.target.value)}><option value="">All periods</option>{(data?.periods || []).map((p) => <option key={p.key} value={p.key}>{`${p.label} · pays ${p.pays_on_label}`}</option>)}</select></label>
      {!data && <p className="projection-loading">Loading pay lines…</p>}
      {data && !data.lines.length && <p className="operations-empty-state" data-testid="progress-notes-pay-lines-empty">No approved progress notes in this period yet.</p>}
      {data && data.lines.length > 0 && (
        <table className="board-table progress-notes-table" data-testid="progress-notes-pay-table">
          <thead><tr><th>Provider</th><th>Goes on</th><th>Pay period</th><th>Line item</th><th>Amount</th></tr></thead>
          <tbody>
            {data.lines.map((line) => (
              <tr key={`${line.provider_id}-${line.period.key}`} data-testid={`pay-line-${line.provider_id}-${line.period.key}`}>
                <td><strong>{line.provider_name}</strong><br /><small>{line.engagement_type || "Engagement not set"}</small></td>
                <td>{line.destination}</td>
                <td>{line.period.label}<br /><small>pays {line.period.pays_on_label}</small></td>
                <td data-testid={`pay-line-text-${line.provider_id}-${line.period.key}`}>{line.line}{line.submissions.length > 1 && <small><br />{line.submissions.map((s) => `${s.client_name} · ${day(s.completed_on)}`).join("; ")}</small>}</td>
                <td><strong>{money(line.amount)}</strong></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
};
